// extracted by mini-css-extract-plugin
module.exports = {"cnt-en":"PrivacyPolicy_cnt-en__3lxxU","cnt":"PrivacyPolicy_cnt__2h2lo"};